import { HttpClient } from "./HttpClient";

export interface AgentStatus {
    id: string;
    name: string;
    color: string;
    description: string;
    isActiveStatus: boolean;
    isSystemDefaultStatus: boolean;
    workspaceId: string;
    clientId: string;
}

export const agentStatusService = {
    async getAgentStatuses(): Promise<AgentStatus[]> {
        const response = await HttpClient.apiClient.get('/agentStatus');
        const data = response.data?.data

        return data;
    },
    async createAgentStatus(payload: Partial<AgentStatus>): Promise<AgentStatus> {
        const response = await HttpClient.apiClient.post('/agentStatus', payload);
        const data = response.data?.data

        return data;
    },
    async updateAgentStatus(id: string, payload: Partial<AgentStatus>): Promise<AgentStatus> {
        const response = await HttpClient.apiClient.post(`/agentStatus/${id}`, payload);
        const data = response.data?.data

        return data;
    },
    async deleteAgentStatus(id: string): Promise<void> {
        await HttpClient.apiClient.delete(`/agentStatus/${id}`);
    },
    async getUserAgentStatuses(): Promise<{
        agentStatusId: string;
        lastActivityTimestamp: string;
    }> {
        const response = await HttpClient.apiClient.get('/user/activity');
        const data = response.data?.data

        return data;
    },
    async updateUserAgentStatus(payload: {
        agentStatusId: string;
    }): Promise<string> {
        await HttpClient.apiClient.post('/user/activity', payload);
        return payload.agentStatusId;
    },
    async updateUserLastActivityTimestamp(): Promise<void> {
        await HttpClient.apiClient.put('/user/activity');
    }
}